module.exports = __webpack_public_path__ + "img/pro_two_10.53843091.jpg";